import { render, staticRenderFns } from "./StdSecureDocsList.vue?vue&type=template&id=351c165d&scoped=true&"
import script from "./StdSecureDocsList.vue?vue&type=script&lang=js&"
export * from "./StdSecureDocsList.vue?vue&type=script&lang=js&"
import style0 from "./StdSecureDocsList.vue?vue&type=style&index=0&id=351c165d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c165d",
  null
  
)

export default component.exports